import React, { useState, useEffect } from 'react';
import { CssBaseline, ThemeProvider, Snackbar, Alert } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

// Importación de componentes
import Topbar from './scenes/global/Topbar';
import Team from "./scenes/team/index";
import Invoices from "./scenes/invoices/index";
import Form from "./scenes/form/index";
import Calendar from "./scenes/calendar/index";

//Dashboard
import DashBoard from "./scenes/dashboard/dashboard.jsx"

//Login
import SignInSide from './views/SignInSide';

//Consulta 
import CCentrifuga from './scenes/consulta/centrifuga';
import CCoTherm2Comp from './scenes/consulta/coTherm 2Comp';
import CCoTherm4Comp from './scenes/consulta/coTherm 4Comp';
import CCoTherm4Comp2CC from './scenes/consulta/coTherm 4Comp2CC';
import CezChiller2Comp from './scenes/consulta/ezChiller 2Comp';
import CezChiller2CompCT6 from './scenes/consulta/ezChiller 2Comp CT6';
import CFullServiceCooling from './scenes/consulta/Full Service Cooling';
import GFSC1Comp from './scenes/grafica/Full Service Cooling 1Comp';
import CFSC1Comp from './scenes/consulta/Full Service Cooling 1Comp';
import CFSCUNICO from './scenes/consulta/Full Service Cooling UNICO';
import CFSCV21Comp from './scenes/consulta/Full Service Cooling V2 1Comp';
import CFSCV3 from './scenes/consulta/Full Service Cooling V3';
import CFSCV31Comp from './scenes/consulta/Full Service Cooling V3 1Comp';
import CLicuador1Comp from './scenes/consulta/Licuador 1Comp';
import COptichiller2Comp from './scenes/consulta/Optichiller 2Comp';
import COptichiller2CompCT6 from './scenes/consulta/Optichiller 2Comp CT6';
import COptichiller1Comp from './scenes/consulta/Optichiller 1Comp';
import COptichiller1CompCT6 from './scenes/consulta/Optichiller 1Comp CT6';
import CVictex1Comp from './scenes/consulta/Victex 1 Compresor';

//Grafica
import GCentrifuga from './scenes/grafica/centrifuga';
import GCoTherm2Comp from './scenes/grafica/coTherm 2Comp';
import GCoTherm4Comp from './scenes/grafica/coTherm 4Comp';
import GCoTherm4Comp2CC from './scenes/grafica/coTherm 4Comp2CC';
import GezChiller2Comp from './scenes/grafica/ezChiller 2Comp';
import GezChiller2CompCT6 from './scenes/grafica/ezChiller 2Comp CT6';
import GFullServiceCooling from './scenes/grafica/Full Service Cooling';
import GFSCUNICO from './scenes/grafica/Full Service Cooling UNICO';
import GFSCV21Comp from './scenes/grafica/Full Service Cooling V2 1Comp';
import GFSCV3 from './scenes/grafica/Full Service Cooling V3';
import GFSCV31Comp from './scenes/grafica/Full Service Cooling V3 1Comp';
import GLicuador1Comp from './scenes/grafica/Licuador 1Comp';
import GOptichiller2Comp from './scenes/grafica/Optichiller 2Comp';
import GOptichiller2CompCT6 from './scenes/grafica/Optichiller 2Comp CT6';
import GOptichiller1Comp from './scenes/grafica/Optichiller 1Comp';
import GOptichiller1CompCT6 from './scenes/grafica/Optichiller 1Comp CT6';
import GVictex1Comp from './scenes/grafica/Victex 1 Compresor';

//Status Maquina
import StatusMaquinas from "./scenes/status";

// 🎨 Tema default sin colorMode
const defaultTheme = createTheme();


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
   () => !!localStorage.getItem("userToken") 
  );
  const navigate = useNavigate();

  const [sessionAlertOpen, setSessionAlertOpen] = useState(false);
  const [sessionAlertMessage, setSessionAlertMessage] = useState("");

  useEffect(() => {
    let sessionExpiredHandled = false;

    const handleSessionExpired = (event) => {
      if (sessionExpiredHandled) return;
      sessionExpiredHandled = true;

      const message =
        event.detail?.message ||
        "Tu sesión expiró por seguridad. Vuelve a iniciar sesión para continuar.";

      setSessionAlertMessage(message);
      setSessionAlertOpen(true);

      setTimeout(() => {
        localStorage.clear();
        setIsAuthenticated(false);
        navigate("/", { replace: true });
      }, 2500);
    };

    window.addEventListener("ems-session-expired", handleSessionExpired);

    return () => {
      window.removeEventListener("ems-session-expired", handleSessionExpired);
    };
  }, [navigate]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <div
        className="app"
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f5f6fa", // ✅ Fondo de la app completo
        }}
      >
          {isAuthenticated && (
            <Topbar setIsAuthenticated={setIsAuthenticated} style={{ margin: 0, padding: 0 }} />
          )}
          <main className="content" style={{ flex: 1, margin: 0, padding: 0, overflow: "auto" }}>
            <Routes>
              {!isAuthenticated ? (
                <>
                  {/* Login */}
                  <Route path="/" element={<SignInSide setIsAuthenticated={setIsAuthenticated} />} />
                  {/* Cualquier 404 sin sesión → login */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </>
              ) : (
                <>
                  {/* Si entra a "/" con sesión → dashboard */}
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />

                  <Route path="/dashboard" element={<DashBoard />} />
                  <Route path="/team" element={<Team />} />
                  <Route path="/consulta_centrifuga" element={<CCentrifuga />} />
                  <Route path="/consulta_cotherm2comp" element={<CCoTherm2Comp />} />
                  <Route path="/consulta_cotherm4comp" element={<CCoTherm4Comp />} />
                  <Route path="/consulta_cotherm4comp2cc" element={<CCoTherm4Comp2CC />} />
                  <Route path="/consulta_ezchiller2comp" element={<CezChiller2Comp />} />
                  <Route path="/consulta_ezchiller2compct6" element={<CezChiller2CompCT6 />} />
                  <Route path="/consulta_fullservicecooling" element={<CFullServiceCooling />} />
                  <Route path="/consulta_fullservicecooling1comp" element={<CFSC1Comp />} />
                  <Route path="/consulta_fullservicecoolingunico" element={<CFSCUNICO />} />
                  <Route path="/consulta_fullservicecoolingv21comp" element={<CFSCV21Comp />} />
                  <Route path="/consulta_fullservicecoolingv3" element={<CFSCV3 />} />
                  <Route path="/consulta_fullservicecoolingv31comp" element={<CFSCV31Comp />} />
                  <Route path="/consulta_licuador1comp" element={<CLicuador1Comp />} />
                  <Route path="/consulta_optichiller2comp" element={<COptichiller2Comp />} />
                  <Route path="/consulta_optichiller2compct6" element={<COptichiller2CompCT6 />} />
                  <Route path="/consulta_optichiller1comp" element={<COptichiller1Comp />} />
                  <Route path="/consulta_optichiller1compct6" element={<COptichiller1CompCT6 />} />
                  <Route path="/consulta_victex1comp" element={<CVictex1Comp />} />

                  <Route path="/grafica_centrifuga" element={<GCentrifuga />} />
                  <Route path="/grafica_cotherm2comp" element={<GCoTherm2Comp />} />
                  <Route path="/grafica_cotherm4comp" element={<GCoTherm4Comp />} />
                  <Route path="/grafica_cotherm4comp2cc" element={<GCoTherm4Comp2CC />} />
                  <Route path="/grafica_ezchiller2comp" element={<GezChiller2Comp />} />
                  <Route path="/grafica_ezchiller2compct6" element={<GezChiller2CompCT6 />} />
                  <Route path="/grafica_fullservicecooling" element={<GFullServiceCooling />} />
                  <Route path="/grafica_fullservicecooling1comp" element={<GFSC1Comp />} />
                  <Route path="/grafica_fullservicecoolingunico" element={<GFSCUNICO />} /> 
                  <Route path="/grafica_fullservicecoolingv21comp" element={<GFSCV21Comp />} />
                  <Route path="/grafica_fullservicecoolingv3" element={<GFSCV3 />} />
                  <Route path="/grafica_fullservicecoolingv31comp" element={<GFSCV31Comp />} />
                  <Route path="/grafica_licuador1comp" element={<GLicuador1Comp />} />
                  <Route path="/grafica_optichiller2comp" element={<GOptichiller2Comp />} />
                  <Route path="/grafica_optichiller2compct6" element={<GOptichiller2CompCT6 />} />
                  <Route path="/grafica_optichiller1comp" element={<GOptichiller1Comp />} />
                  <Route path="/grafica_optichiller1compct6" element={<GOptichiller1CompCT6 />} />
                  <Route path="/grafica_victex1comp" element={<GVictex1Comp />} />
                  <Route path="/invoices" element={<Invoices />} />
                  <Route path="/form" element={<Form />} />
                  <Route path="/calendar" element={<Calendar />} />
                  <Route path="/status" element={<StatusMaquinas />} />

                  {/* Cualquier 404 con sesión → dashboard */}
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </>
              )}
            </Routes>
          </main>
         </div>

        <Snackbar
          open={sessionAlertOpen}
          autoHideDuration={2500}
          onClose={() => setSessionAlertOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            severity="warning"
            variant="filled"
            onClose={() => setSessionAlertOpen(false)}
            sx={{ width: "100%" }}
          >
            {sessionAlertMessage}
          </Alert>
        </Snackbar>
      </ThemeProvider>
  );
}

export default App;





